import { BriefcaseBusiness, MessageCircle, ShieldCheck } from "lucide-react";

const BENEFITS = [
  {
    icon: ShieldCheck,
    title: "Verified employers",
    copy: "You can trust who you connect with.",
  },
  {
    icon: BriefcaseBusiness,
    title: "Genuine opportunities",
    copy: "Real roles from real companies.",
  },
  {
    icon: MessageCircle,
    title: "Better conversations",
    copy: "Communicate authentically.",
  },
];

/** Left marketing panel for the ND1 sign-up page. */
export default function Nd1SignupMarketing() {
  return (
    <aside
      className="nd1-auth-aside nd1-auth-aside--signup"
      aria-label="Why create a JOBUWIN account"
      style={{ backgroundImage: "url(/images/signup-panel-background.png)" }}
    >
      <span className="nd1-eyebrow-chip nd1-signup-badge">
        <ShieldCheck className="nd1-icon" aria-hidden="true" />
        Genuine accounts only
      </span>

      <div className="nd1-signup-aside__copy">
        <h1 className="nd1-signup-aside__title">
          Built for <span className="nd1-ink-green">genuine</span> people.
        </h1>
        <p className="nd1-signup-aside__lede">Communicate the real you, not just a polished CV.</p>
      </div>

      <ul className="nd1-signup-benefits">
        {BENEFITS.map(({ icon: Icon, title, copy }) => (
          <li key={title}>
            <span className="nd1-signup-benefits__icon">
              <Icon className="nd1-icon" aria-hidden="true" />
            </span>
            <span className="nd1-signup-benefits__body">
              <strong>{title}</strong>
              <span>{copy}</span>
            </span>
          </li>
        ))}
      </ul>
    </aside>
  );
}
